/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const ddam: Solution = {
  appId: 'ddam',
  distributionList: ['ORG-VUROSEV-ALL@adobe.com'],
  metricsAppId: 'assets',
  path: '/assets',
  analytics: {
    code: 'aae',
    scripts: {
      dev: '//assets.adobedtm.com/a7d65461e54e/53397f479116/launch-f1c48b3d4df1-development.min.js',
      qa: '//assets.adobedtm.com/a7d65461e54e/53397f479116/launch-f1c48b3d4df1-development.min.js',
      stage: '//assets.adobedtm.com/a7d65461e54e/53397f479116/launch-5b37e6c4a0c2-staging.min.js',
      prod: '//assets.adobedtm.com/a7d65461e54e/53397f479116/launch-60c8793b1f21.min.js'
    }
  },
  gainsight: {productKey: 'AP-GGNFMVCRYIQI-2'},
  sandbox: {
    hideInitialSpinner: true,
    history: HISTORY.HASH,
    ims: {
      client_id: 'aem-assets-frontend-1',
      scope: 'AdobeID,openid,read_organizations,ab.manage,additional_info.projectedProductContext'
    },
    sources: {
      // TODO: leave for now but this should be removed after people have time to switch to dev443
      devcjm: 'https://localhost.corp.adobe.com:443/',
      dev443: 'https://localhost.corp.adobe.com:443/',
      dev: 'https://localhost.corp.adobe.com:8443/',
      qa: 'https://experience-qa.adobe.com/solutions/ddam',
      stage: 'https://experience-stage.adobe.com/solutions/ddam',
      prod: 'https://experience.adobe.com/solutions/ddam'
    }
  },
  access: {
    code: ['dma_media_library', 'dma_ddam'],
    flag: 'assets-essentials-enabled'
  }
};

export default ddam;
